// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3ft_y","modalForm":"UpgradeEpcsModal_modalForm__1U7L-","modalFooter":"UpgradeEpcsModal_modalFooter__1b8mN"};